import { __awaiter } from "tslib";
import { DaySelectedService } from "@/services/models/schedule/daySelected";
const moduleDaySelected = {
    namespaced: true,
    state: {
        daySelecteds: [],
        loading: false,
        daySelected: null,
    },
    getters: {
        getDaySelecteds(state) {
            return state.daySelecteds;
        },
        getDaySelected(state) {
            return state.daySelected;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setDaySelecteds(state, daySelecteds) {
            state.daySelecteds = daySelecteds;
        },
        setDaySelected(state, daySelected) {
            state.daySelected = daySelected;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        getDaySelected({ commit }, id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit('setLoading', true);
                const DAY_SELECTED = yield DaySelectedService.getById(id);
                commit('setDaySelected', DAY_SELECTED);
                commit('setLoading', false);
            });
        },
    }
};
export default moduleDaySelected;
